import React, { useState } from 'react'
import PropTypes from 'prop-types'
import _, { isEmpty } from 'lodash'
import { Button, Col, Form, Icon, Input, Modal, Radio, Row, Upload } from 'antd'
import { useDeepEffect } from '../../../utils/hooks'
const CoinTransactionForm = (props) => {
  const { visible, onOk, onCancel, formData, form } = props
  const { getFieldDecorator, validateFields, setFieldsValue } = form

  useDeepEffect(() => {
    if (!isEmpty(formData)) {
      setFieldsValue({
        status: formData.status,
      })
    }

    return () => {
      form.resetFields()
    }
  }, [formData])

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          status: values.status,
        }
        if (!_.isEmpty(formData)) {
          data.packageTransactionId = formData.id
        }
        onOk(data)
      }
    })
  }

  return (
    <Modal
      title={`Update Status`}
      visible={visible}
      footer={null}
      onCancel={onCancel}>
      <Form form={form} onSubmit={onSubmit} layout="vertical">
      <Form.Item label="Status">
        {getFieldDecorator(`status`, {
          rules: [
            {
              required: true,
              message: 'กรุณาเลือก'
            }
          ]
        })(
          <Radio.Group>
            <Radio value={'ADDCOIN_SUCCESS'}>หลักฐานถูกต้อง</Radio>
            <Radio value={'PAYMENT_INVALID'}>หลักฐานไม่ถูกต้อง</Radio>
          </Radio.Group>
        )}
      </Form.Item>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <Button color="#6ebf4b" type="primary" htmlType="submit">
              บันทึก
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const WrappedCoinTransactionForm = Form.create({ name: 'CoinTransactionForm' })(
  CoinTransactionForm
)
export default WrappedCoinTransactionForm
